// extracted by mini-css-extract-plugin
module.exports = {"upgrade-banner":"UpgradeBanner_upgrade-banner__ZCodH","upgrade-banner-text":"UpgradeBanner_upgrade-banner-text__B3HbT"};